var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaitChoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 238 216",
    style: {
      enableBackground: "new 0 0 238 216"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.wait-choice0{fill:#39003C;}\n\t.wait-choice1{fill:#FDCBC7;}\n\t.wait-choice2{fill:#FFFFFF;}\n\t.wait-choice3{fill:#70ACFB;}\n\t.wait-choice4{fill:#FAE9E7;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1_00000143601326960842558330000009976532541184134046_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1_00000084532449333784459120000016989126683040453810_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_17"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "wait-choice0",
    cx: 119.3,
    cy: 110.9,
    r: 90
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "wait-choice1",
    d: "M161.5,159.5l3.8,15.5l-1.7,9.5l-0.9,4.9l-0.9,5.2c-3.4,1.7-6.9,3.3-10.6,4.6l-21,5c-3.6,0.4-7.3,0.7-11,0.7 c-37.1,0-69.2-21.6-84.5-52.9c-0.6-1.2-1.2-2.4-1.7-3.7l-5.9-18.4c-1.3-6.1-1.9-12.5-1.9-19c0-7.8,0.9-15.3,2.7-22.5 c0.7-2.8,1.5-5.6,2.5-8.3l6.3,1l1.8,0.3L163.3,101l3.8,0.6l0.5,4.7l2.5,25.7L161.5,159.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wait-choice0",
    d: "M162.3,159.3l4,16l-3.5,14.2l-50.5,13l2.6-7.2c0,0-6.1-9.2-6.1-9.9c0-0.7,2.6-34.5,2.6-34.5l4.2-8.1l-1.3-7.5 l2.9-5.7c0,0,0-5.7,0-6.4c0-0.7,2.5,4.6,2.5,4.6l-0.7,3.5l4.7-1.5l20.4-6.6l11.4,6.6l5.3-1.1l2.5-27.7l4.4,0.7l2.9,30.4 L162.3,159.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "wait-choice1",
    points: "132.1,143.3 130.4,139.3 141.1,132.9 154.4,136 158.9,140.2 157.3,144.4 151.3,145.1 145.8,142.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "wait-choice1",
    points: "123.5,159.1 141.1,164.6 150.4,164.6 152.8,163.7 155.3,169 150.1,170.3 131.2,169.2 127.3,165.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "wait-choice2",
    points: "140.8,161 143,156.3 141.9,151.7 139.3,149.2 147.9,151.2 151.8,157.8 151.8,161 144.7,161.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "wait-choice2",
    points: "137.8,150.4 136.3,150.4 135.7,152.3 137.3,152.9 138.2,151.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "wait-choice3",
    points: "139.9,153.5 138.2,154.3 137.4,156.7 135.7,157.6 133,157.4 133.7,158.9 137,159.3 139.4,157.7  140.3,155.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "wait-choice0",
    points: "102.8,145.1 100.1,150.4 94,170.3 96,178.8 91.3,183.4 81.1,182.8 73.8,187.3 67.6,180 67.6,173  76.6,170.3 82,170.3 95.2,153.5 96.6,146.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "wait-choice0",
    points: "88,151.7 82,155.3 80.1,161.4 74.1,162.9 71.2,164.7 66.6,160.3 49.5,156.4 46.6,154.7 44.2,154.3  46,152.9 49.3,152.9 53.7,151.7 73.3,152.9 85.2,150.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "wait-choice0",
    points: "96,141.7 101,139 107.9,139 111.1,129.5 111.1,124.8 109.3,126.3 106,132.9 97.1,135.8 95.3,139  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "wait-choice0",
    points: "89.3,141.7 84,138.5 84,132.9 83.2,130 83.6,128.4 86.8,131 88.8,138.1 90.3,140.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "wait-choice2",
    points: "75.7,144.2 76.5,131.5 60.7,126.2 55.3,133.3 58.7,143.6 70,146.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "wait-choice0",
    d: "M103.8,120.3v6.3l-12.3,7.3l-2.9-3.8l-12-13.2l-4.4-5.4H52.9l-3.4,2l0.3,4.4l-0.7,1.5l22.8,3.2l5.4,4.1 l4.4,9.2l-0.6,1.6l2,8l-2,0.6l-2.2-1.1l-7.3,1.9l1-1.7v0l1.1-1.9l0.9-6.2l-4.5-4.8l-9.5-2.2l2.5,3.1l-0.2,3.6l-2.2,4.8l7.9,2.5 l1.5,1.9l-11.7-0.2l-16.4-4.2l2.9,7.6l-2.2,0.6l-7.9,2.2c-0.6-1.2-1.2-2.4-1.7-3.7l-5.9-18.4c-1.3-6.1-1.9-12.5-1.9-19 c0-7.8,0.9-15.3,2.7-22.5l6.1-0.2l2.2-0.1l10.5-0.4h0l11.6-0.4L74.6,94l10.6,4.3l-1,4.6l-1.1,5l4.8,7.8l10.1,3.4L103.8,120.3z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "wait-choice2",
    points: "56.8,134.2 58.6,133.3 58.6,132.2 56.6,131.6 56,132.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "wait-choice3",
    points: "57.6,136.1 60,135 59.5,138.3 57.9,139.7 54.1,140.3 51.5,139.3 56,139 57.5,137.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "wait-choice4",
    points: "178.4,146.1 174.6,146.9 173.4,151.7 177,154.7 181.2,152.9 181.2,149.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "wait-choice4",
    points: "181.2,139 184.4,145.1 190.3,146.9 193.9,141.7 193.2,136.1 186.5,134.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "wait-choice4",
    points: "197.3,128.4 187.6,129.1 182.4,122.6 185.2,114.2 189.8,110.9 199.6,113.1 202.9,119.8 201.1,127.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "wait-choice4",
    d: "M210.8,97.9l-6.2,2.2l-8.7,3.1L179,99.7l-9.1,6.2l-1.8,0.3l-0.6,0.1l-4.8,0.8l-5.2,0.9l-12.8-5.2l-7.7,3.5 h-9.8l-16.1-6.4l-12,4.9l-13.9-1l-1-0.9l-9.6-9L60,95.6l-13.1-7.8h0l-6.1,2.8h-7.4l0.9-2.3l2.6-7.1l11.8-32l0,0v0 c2.5-2.9,5.3-5.7,8.2-8.2l0,0l28.9-17.7c0,0,0,0,0,0c0,0,0,0,0,0h59l34.8,15.6l0,0c5.8,4.8,11,10.3,15.5,16.4c0,0,0,0,0,0 L210.8,97.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wait-choice2",
    d: "M194.9,55.1C194.9,55.1,194.9,55.1,194.9,55.1c-4.5-6.1-9.7-11.6-15.5-16.4l0,0 c-16.3-13.6-37.3-21.8-60.1-21.8c-11.8,0-23.2,2.2-33.6,6.2c0,0,0,0,0,0c0,0,0,0,0,0c-10.7,4.1-20.5,10.1-28.9,17.7l0,0 c-2.9,2.6-5.6,5.3-8.2,8.2v0l0,0c-7.9,9-14.1,19.5-18.1,31c-1,2.7-1.8,5.5-2.5,8.3c-1.8,7.2-2.7,14.8-2.7,22.5 c0,6.5,0.7,12.9,1.9,19c1.3,6.4,3.3,12.6,5.9,18.4c0.5,1.2,1.1,2.5,1.7,3.7c15.3,31.3,47.4,52.9,84.5,52.9c3.7,0,7.4-0.2,11-0.7 c7.3-0.8,14.3-2.5,21-5c3.6-1.3,7.2-2.8,10.6-4.6c30.5-15.5,51.5-47.3,51.5-83.8C213.3,90,206.5,70.7,194.9,55.1z M164,184.3 L164,184.3c-0.2,0.1-0.3,0.2-0.4,0.3c-12.9,7.8-28.1,12.3-44.3,12.3c-1.7,0-3.3-0.1-4.9-0.1h0c-13.6-0.8-26.5-4.8-37.7-11.2h0 c-3.1-1.8-6.1-3.8-9-5.9c-9-6.8-16.7-15.4-22.5-25.2v0c-0.1-0.2-0.2-0.4-0.4-0.6c-0.8-1.3-1.5-2.6-2.1-4c-6-11.7-9.3-24.9-9.3-38.9 c0-7,0.9-13.9,2.5-20.4c0.2-0.8,0.4-1.6,0.6-2.4c0.6-2.3,1.3-4.5,2.2-6.8c12.1-32.9,43.7-56.5,80.8-56.5c43.8,0,80,32.9,85.3,75.2 c0.4,3.5,0.7,7.1,0.7,10.8C205.3,141.9,188.8,169.2,164,184.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "wait-choice0",
    d: "M83.2,60.5c-2.9,0.2-5.4,1.9-5.9,5.8h-0.8l1.1-12h-4.7v27h4.4l-0.1-10.7c0-5.8,5.5-5.9,5.5-5.9 c4.8-0.2,4.3,6.2,4.3,6.2v10.5h4.4v-12C91.3,69.3,91.7,59.8,83.2,60.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wait-choice0",
    d: "M107.5,60.5v10.7c0,5.9-5.4,5.9-5.5,5.9c-4.7,0.2-4.2-6.2-4.2-6.2V60.5h-4.4v12c0,0-0.4,9.4,8.1,8.7 c2.9-0.2,5.2-1.9,5.7-5.5h1.1l-1.2,5.5h4.7V60.5H107.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wait-choice0",
    d: "M140,60.5c-4.7-0.5-8.5,2-8.9,5.8h-0.9c-0.2-3.6-2.4-5.8-5.6-5.8c-2.8,0-5.4,1.9-5.9,5.8h-1l1.2-5.8h-4.7 v20.7h4.4V70.6c0.1-6,5.5-5.9,5.5-5.9c3.3-0.1,4.2,2.8,4.2,4.7v11.9h4.4V69.4c-0.1-3.3,3.5-5.8,6.6-4.7c2.5,1,3.1,3.7,3.1,6.1 v10.4h4.4v-12C146.9,69.1,146.9,61.2,140,60.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wait-choice0",
    d: "M155.7,75.7c-1.5,0-2.8,1.2-2.8,2.8c0,1.5,1.2,2.8,2.8,2.8s2.8-1.2,2.8-2.8C158.5,77,157.2,75.7,155.7,75.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wait-choice0",
    d: "M163.5,75.7c-1.5,0-2.8,1.2-2.8,2.8c0,1.5,1.2,2.8,2.8,2.8c1.5,0,2.8-1.2,2.8-2.8 C166.3,77,165.1,75.7,163.5,75.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wait-choice0",
    d: "M171.4,75.7c-1.5,0-2.8,1.2-2.8,2.8c0,1.5,1.2,2.8,2.8,2.8c1.5,0,2.8-1.2,2.8-2.8 C174.2,77,172.9,75.7,171.4,75.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitChoice);
export default __webpack_public_path__ + "static/media/wait-choice.e38edb3705c5b686b49814ad7a9e3d5f.svg";
export { ForwardRef as ReactComponent };